import { connect } from 'react-redux'
import { compose, withHandlers, withState } from 'recompose'
import { show } from 'redux-modal'
import FleetCertified from './FleetCertified'
import { FLEET_CERTIFIED_MODAL } from 'components/StoreDetailsPage/constants'

const withIsHoveredState = withState('isHovering', 'setIsHovering', false)
const withIsTooltipHoveredState = withState('isTooltipHovering', 'setIsTooltipHovering', false)

const withShowModalHandler = withHandlers({
  showModal: ({ show }) => () => {
    show(FLEET_CERTIFIED_MODAL)
  }
})

const withInfoIconOnHoverHandler = withHandlers({
  showModalOnHover: ({ showModal, setIsTooltipHovering }) => () => {
    setIsTooltipHovering(true)
    setTimeout(() => showModal(), 500)
  }
})

export default compose(
  connect(null, { show }),
  withIsHoveredState,
  withIsTooltipHoveredState,
  withShowModalHandler,
  withInfoIconOnHoverHandler
)(FleetCertified)

